import { Link } from 'react-router-dom';
import { videoCategories, weeklyRanking } from '@/mocks/homeData';
import AnimatedSection from '@/components/base/AnimatedSection';

export default function CategorySection() {
  return (
    <section className="relative py-20 md:py-28 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <AnimatedSection>
        {/* Section header */}
        <div className="text-center mb-16">
          <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full border border-primary-500/40 text-primary-400 mb-4">
            热门分类
          </span>
          <h2 className="text-[clamp(2rem,4vw,3.5rem)] font-black text-foreground-50 tracking-[-0.02em] mb-4">
            吃瓜不迷路
          </h2>
          <p className="text-base text-foreground-600 max-w-lg mx-auto">
            四大分类精准导航，你想看的这里都有
          </p>
        </div>
        </AnimatedSection>

        <AnimatedSection animation="fade-up">
        {/* Category cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-16">
          {videoCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:bg-primary-500/10 hover:border-primary-500/40 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-background-100 mb-4 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${cat.icon} text-2xl group-hover:text-primary-400 text-foreground-300 transition-colors`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-100 mb-2 group-hover:text-primary-400 transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 mb-4 leading-relaxed">
                {cat.description}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-700">
                  {cat.count.toLocaleString()} 条视频
                </span>
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-background-200 group-hover:bg-primary-500 group-hover:text-background-950 transition-all duration-300">
                  <i className="ri-arrow-right-line text-sm text-foreground-500 group-hover:text-background-950"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
        </AnimatedSection>

        <AnimatedSection animation="fade-up">
        {/* Ranking section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Weekly ranking */}
          <div className="p-6 rounded-2xl bg-background-50 border border-background-200/70">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/20">
                <i className="ri-fire-line text-primary-400 text-lg"></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-100">本周热榜</h3>
            </div>
            <div className="space-y-1">
              {weeklyRanking.map((item) => (
                <div
                  key={item.rank}
                  className="flex items-center gap-4 px-3 py-3 rounded-lg hover:bg-background-100 transition-colors cursor-pointer group"
                >
                  <span
                    className={`w-7 h-7 flex items-center justify-center rounded-lg text-xs font-bold flex-shrink-0 ${
                      item.rank <= 3
                        ? 'bg-primary-500 text-background-950'
                        : 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    {item.rank}
                  </span>
                  <span className="text-sm text-foreground-300 flex-1 truncate group-hover:text-foreground-100 transition-colors">
                    {item.title}
                  </span>
                  <span className="text-xs text-foreground-600 whitespace-nowrap flex items-center gap-1">
                    {item.trend === 'up' && (
                      <span className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-arrow-up-line text-accent-500 text-xs"></i>
                      </span>
                    )}
                    {item.trend === 'down' && (
                      <span className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-arrow-down-line text-foreground-700 text-xs"></i>
                      </span>
                    )}
                    {item.trend === 'new' && (
                      <span className="text-primary-400 text-[10px] font-semibold">NEW</span>
                    )}
                    {item.views}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* About site card */}
          <div className="p-6 rounded-2xl bg-background-50 border border-background-200/70 flex flex-col justify-center">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-500/15 flex-shrink-0">
                <i className="ri-flashlight-line text-accent-400 text-2xl"></i>
              </div>
              <div>
                <h3 className="text-lg font-bold text-foreground-100 mb-2">为什么选择黑料视频？</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们坚持凌晨零点准时更新，所有内容来自网友爆料和一线狗仔投稿。没有公关洗白，没有资本控评，只有最真实的第一手内幕。每天 <strong className="text-primary-400">10万+</strong> 瓜友在线蹲守，你要的猛料这里都有。
                </p>
              </div>
            </div>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 text-sm font-semibold text-primary-400 hover:text-primary-300 transition-colors cursor-pointer"
            >
              了解更多
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>
        </div>
        </AnimatedSection>
      </div>
    </section>
  );
}